// FinMaple Score - 5-pillar editorial scoring for Canadian credit cards
// Weights: Costos 30%, Newcomer 25%, Digital 15%, Beneficios 15%, Español 15%

const digitalRatings = {
  'Neo Financial': 5.0,
  'Tangerine': 4.5,
  'EQ Bank': 4.5,
  'TD': 4.0,
  'RBC': 4.0,
  'BMO': 3.8,
  'CIBC': 3.8,
  'Scotiabank': 3.7,
  'Desjardins': 3.5,
  'National Bank': 3.5,
  default: 3.0,
};

const spanishRatings = {
  Scotiabank: 5.0,
  TD: 4.0,
  RBC: 3.5,
  BMO: 3.0,
  CIBC: 3.0,
  Desjardins: 3.5,
  default: 2.5,
};

export function calculateFinMapleScore(card) {
  // Costos (30%)
  const feeStr = String(card.annual_fee || '').toLowerCase();
  let fee = 0;
  if (!feeStr.includes('no annual fee')) {
    const m = feeStr.match(/([\d.]+)/);
    fee = m ? parseFloat(m[1]) : 0;
  }
  const costos =
    fee === 0 ? 5.0 : fee < 60 ? 4.0 : fee < 120 ? 3.0 : fee < 200 ? 2.0 : 1.0;

  // Newcomer (25%)
  const newcomer = card.newcomer_friendly ? 5.0 : 2.5;

  // Digital (15%)
  const digital = digitalRatings[card.bank] || digitalRatings.default;

  // Beneficios (15%)
  const rewards = (card.rewards || '').toLowerCase();
  const beneficios =
    rewards.includes('%') || rewards.includes('cash back')
      ? 5.0
      : rewards.includes('point') || rewards.includes('punto') || rewards.includes('mile')
      ? 3.5
      : 2.0;

  // Español (15%)
  const espanol = spanishRatings[card.bank] || spanishRatings.default;

  const total =
    costos * 0.3 + newcomer * 0.25 + digital * 0.15 + beneficios * 0.15 + espanol * 0.15;

  return {
    total: Math.round(total * 10) / 10,
    breakdown: { costos, newcomer, digital, beneficios, espanol },
  };
}
